module.exports = __webpack_public_path__ + "img/reset-close.7abc4115.svg";